import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-data-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class TaskUpdateTaskDataApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Update Task Score and Status",
            description:
                "This endpoint can be used to update an existing task score and status. This is only available for tasks that are currently in status 'To do'  or ' Rejected' ",
            httpMethod: "POST",
            path: "/taskdata/v1/tasks/{guid}",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the task  to update",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "score",
                    description:
                        "ID of the score to set on the task. These can be retrieved with the Task Score direct data API",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1",
                },
                {
                    name: "submit",
                    description:
                        "whether to submit the task after updating the score. Updates to 'Done' if no reviewer was set. Updates to 'Ready for review' if a reviewer was set. If omitted, defaults to false",
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: "true",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
